import { useEffect, useRef, DependencyList, EffectCallback } from 'react';
export const useDidUpdateEffect = (effect: EffectCallback, deps?: DependencyList): void => {
  const renderCount = useRef<number>(0);
  const isDev = process.env.NEXT_PUBLIC_APP_ENV === 'development';
  useEffect(() => {
    renderCount.current += 1;

    // Skip 2 renders only in development (where strict mode double render occurs)
    if (isDev && renderCount.current <= 2) {
      return;
    }

    // Skip 1 render only in production (normal mode initial render)
    if (!isDev && renderCount.current === 1) {
      return;
    }
    return effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};